import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { userKeys } from '@/lib/query/keys/user';
import { isSuccess } from '@/lib/utils/response';
import { UserHub } from '@addmile/backend-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UserData {
  user: UserHub;
}

export const useUpdateUserName = (userEmail: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId, name }: { userId: string; name: string }) => {
      const token = await getAuthToken();
      const response = await hubApi.updateUserNameHub(userId, { name }, withAuthHeader(token));
      if (!isSuccess(response.status)) {
        throw new Error(response.statusText || 'Failed to update name');
      }
      return name;
    },

    onSuccess: (newName, { userId }) => {
      queryClient.invalidateQueries({ queryKey: userKeys.details(userEmail) });

      queryClient
        .getQueryCache()
        .findAll()
        .forEach((query) => {
          if (Array.isArray(query.queryKey) && query.queryKey[0] === 'users') {
            const data = queryClient.getQueryData(query.queryKey) as UserData;

            if (data?.user?.id === userId) {
              queryClient.setQueryData(query.queryKey, {
                ...data,
                user: { ...data.user, name: newName },
              });
            }
          }
        });
    },
  });
};
